import { trackExperimentViewed as trackEV } from '@mc/track-event'
import { BUNDLING_TOOLKIT_AND_CERTIFICATES_FLAG_NAME } from '../constants'

export const trackExperimentViewed = () => {
  trackEV(BUNDLING_TOOLKIT_AND_CERTIFICATES_FLAG_NAME)
}
